export const ANNOUNCEMENT_ROOT = "/announcement";
export const BANNER_GET = ANNOUNCEMENT_ROOT + "/banner";
export const BANNER_UPDATE = ANNOUNCEMENT_ROOT + "/banner/update";

export const POPUP_ROOT = ANNOUNCEMENT_ROOT + "/popup";
export const POPUP_LIST = POPUP_ROOT + "/list";
export const POPUP_INSERT = POPUP_ROOT + "/insert";
export const POPUP_UPDATE = POPUP_ROOT + "/update";
export const PUSH_TOKEN_ROOT = "/pushToken";
export const GAME_VIDEO_ROOT = "/gameVideo";
export const GAME_VIDEO_UPDATE = GAME_VIDEO_ROOT + GAME_VIDEO_ROOT + "/update";
export const GAME_VIDEO_INSERT = GAME_VIDEO_ROOT + "/insert";